import {HttpClient, HttpHeaders} from '@angular/common/http';
import { inject, Service } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {Product} from '../products/product';
import {ProductHeader} from '../products/product-header';
import {Riser} from '../products/riser';
import {GoogleService} from './google-service';

@Service()
export class ProductService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public search(term: string): Observable<ProductHeader[]> {
    let url = this.urlBase + 'products/search/' + term;
    return this.http.get<ProductHeader[]>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

  public loadProduct(productId: string): Observable<Product> {
    let url = this.urlBase + 'products/' + productId;
    return this.http.get<Product>(url, {headers: this.getRequestHeaders()});
  }

  public save(product: Product): Observable<string> {
    let url = this.urlBase + 'products/save';
    let body = JSON.stringify(product);
    return this.http.post(url, body, {headers: this.getPostHeaders(), responseType: 'text'});
  }

  public getRisers(): Observable<Riser[]> {
    let url = this.urlBase + 'products/getRisers';
    return this.http.get<Riser[]>(url, {headers: this.getRequestHeaders()});
  }

  getProductConfigurations(): Observable<Product[]> {
    const url = this.urlBase + 'products/productConfigurations';
    return this.http.get<Product[]>(url, {headers: this.getRequestHeaders()});
  }

  getSureFlowConfigurations(): Observable<Product[]> {
    const url = this.urlBase + 'products/sureFlowConfigurations';
    return this.http.get<Product[]>(url, {headers: this.getRequestHeaders()});
  }

  getProductSkuSlots(productId: string): Observable<string[]> {
    const url = this.urlBase + 'products/skuSlots/' + encodeURIComponent(productId);
    return this.http.get<string[]>(url, {headers: this.getRequestHeaders()});
  }

  saveProductSkuSlots(productId: string, slots: string[]): Observable<string> {
    const url = this.urlBase + 'products/skuSlots/' + encodeURIComponent(productId);
    const body = JSON.stringify(slots);
    return this.http.post(url, body, {headers: this.getPostHeaders(), responseType: 'text'});
  }

  getProductById(id: string): Observable<Product> {
    const url = this.urlBase + 'products/' + id;
    return this.http.get<Product>(url, { headers: this.getRequestHeaders() });
  }
}
